// extracted by css-extract-rspack-plugin
export default {"sceneContainer":"hXQNxp","treeLeft":"mU7sbh","treeRight":"_afZxz","ticket":"TZ8iFu"};